(function () {
  // Only trigger if ?thankyou is in the URL
  if (!window.location.search.includes('thankyou')) return;

  // ── Inject styles ──────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&family=DM+Sans:wght@300;400&display=swap');

    #ty-overlay {
      position: fixed;
      inset: 0;
      background: rgba(10, 8, 6, 0.72);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      animation: ty-fade-in 0.5s ease forwards;
    }

    #ty-modal {
      background: #faf8f5;
      border: 1px solid #e8e2d9;
      border-radius: 4px;
      padding: 56px 52px 48px;
      max-width: 480px;
      width: calc(100% - 40px);
      text-align: center;
      position: relative;
      transform: translateY(24px);
      opacity: 0;
      animation: ty-slide-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.15s forwards;
      box-shadow: 0 32px 80px rgba(0,0,0,0.18);
    }

    #ty-icon {
      width: 56px;
      height: 56px;
      margin: 0 auto 28px;
      background: #1a1612;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #ty-icon svg {
      width: 24px;
      height: 24px;
      stroke: #faf8f5;
      fill: none;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-dasharray: 40;
      stroke-dashoffset: 40;
      animation: ty-draw 0.6s ease 0.6s forwards;
    }

    #ty-modal h2 {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 32px;
      font-weight: 600;
      color: #1a1612;
      margin: 0 0 12px;
      letter-spacing: -0.02em;
      line-height: 1.15;
    }

    #ty-modal p {
      font-family: 'DM Sans', sans-serif;
      font-size: 15px;
      font-weight: 300;
      color: #6b6560;
      margin: 0 0 36px;
      line-height: 1.65;
    }

    #ty-close-btn {
      font-family: 'DM Sans', sans-serif;
      font-size: 13px;
      font-weight: 400;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #faf8f5;
      background: #1a1612;
      border: none;
      padding: 14px 36px;
      border-radius: 2px;
      cursor: pointer;
      transition: background 0.2s ease, transform 0.15s ease;
    }

    #ty-close-btn:hover {
      background: #3a3028;
      transform: translateY(-1px);
    }

    #ty-x-btn {
      position: absolute;
      top: 18px;
      right: 18px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 6px;
      color: #b0a89e;
      line-height: 1;
      font-size: 18px;
      transition: color 0.2s;
    }

    #ty-x-btn:hover { color: #1a1612; }

    #ty-overlay.ty-closing {
      animation: ty-fade-out 0.35s ease forwards;
    }

    #ty-overlay.ty-closing #ty-modal {
      animation: ty-slide-down 0.35s cubic-bezier(0.4, 0, 1, 1) forwards;
    }

    @keyframes ty-fade-in  { to { opacity: 1; } }
    @keyframes ty-fade-out { to { opacity: 0; } }
    @keyframes ty-slide-up { to { transform: translateY(0); opacity: 1; } }
    @keyframes ty-slide-down { to { transform: translateY(20px); opacity: 0; } }
    @keyframes ty-draw { to { stroke-dashoffset: 0; } }
  `;
  document.head.appendChild(style);

  // ── Build modal HTML ───────────────────────────────────────────
  const overlay = document.createElement('div');
  overlay.id = 'ty-overlay';
  overlay.innerHTML = `
    <div id="ty-modal" role="dialog" aria-modal="true" aria-labelledby="ty-title">
      <button id="ty-x-btn" aria-label="Close">&#x2715;</button>
      <div id="ty-icon">
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
      <h2 id="ty-title">Thank You!</h2>
      <p>Your order has been placed successfully.<br>We appreciate your support and will be in touch soon.</p>
      <button id="ty-close-btn">Continue Shopping</button>
    </div>
  `;
  document.body.appendChild(overlay);

  // ── Clean ?thankyou from URL without reload ────────────────────
  function cleanUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('thankyou');
    // Also handle bare ?thankyou (no value)
    let search = url.search;
    search = search.replace(/[?&]thankyou(?==|&|$)/g, '').replace(/^&/, '?').replace(/^\?$/, '');
    const cleanHref = url.origin + url.pathname + search + url.hash;
    window.history.replaceState({}, document.title, cleanHref);
  }

  // ── Close logic ────────────────────────────────────────────────
  function closeModal() {
    overlay.classList.add('ty-closing');
    overlay.addEventListener('animationend', () => {
      overlay.remove();
      cleanUrl();
    }, { once: true });
  }

  document.getElementById('ty-close-btn').addEventListener('click', closeModal);
  document.getElementById('ty-x-btn').addEventListener('click', closeModal);

  // Close on backdrop click
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });
})();
